import React, { useState, useRef } from "react";
// import tactosImage from "../assest/l2.svg";
import tactosImage from "../assest/tactos.png";
import "../styles/AboutUs.css";
import "../styles/RainEffect.css";

function AccordionWithInitialState({ title, children, isOpen, onToggle }) {
  const contentRef = useRef(null);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden transition-all duration-500">
      <button
        onClick={onToggle}
        className="w-full p-4 sm:p-6 flex justify-between items-center hover:bg-gray-50 transition-colors rounded-xl group"
      >
        <span
          className={`font-medium text-left text-base sm:text-lg ${isOpen
            ? "text-[#fd3e3d]"
            : "text-gray-800"
            }`}
        >
          {title}
        </span>
        <span className="text-gray-400 text-2xl sm:text-xl font-light">
          {isOpen ? "×" : "+"}
        </span>
      </button>

      {isOpen && (
        <div className="px-4 sm:px-6 border-t border-gray-100 overflow-hidden">
          <div ref={contentRef} className="pb-4 sm:pb-6 text-gray-600 text-sm sm:text-base pt-4">
            {children}
          </div>
        </div>
      )}
    </div>
  );
}

export default function Mission() {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-10 mt-4" id="startupreadlines">
      <div className="flex flex-col justify-center align-middle lg:flex-row lg:space-x-12">
        {/* Left Column: Accordions */}

        <div className="w-full lg:w-1/2 space-y-5 sm:space-y-6 mt-8">

          {/* Heading */}
          <h2 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-900 leading-tight">
            TACTOS The{" "}
            <span className="text-[#fd3e3d]">Start-up Valley</span>{" "}
            for accelerating Indicorns
          </h2>


          {/* Intro */}
          <p className="text-gray-700 text-sm md:text-md leading-relaxed text-justify">
            <span className="font-semibold text-gray-900">TACTOS</span> is India’s
            integrated startup accelerator - a result-driven impact organization that
            empowers startups to grow faster through structured acceleration programs,
            curated investor connections, and access to essential startup resources.
          </p>

          {/* Core Approach */}
          <p className="text-gray-700 text-sm md:text-md leading-relaxed text-justify">
            TACTOS follows a holistic approach by operating across multiple vertical
            models, bridging every critical gap in the startup journey - from ideation
            to investment. Our mission is to transform India’s untapped entrepreneurial
            potential into globally competitive enterprises.
          </p>

          {/* Mission */}
          <p className="text-gray-700 text-sm md:text-md leading-relaxed text-justify">
            We nurture the next generation of
            <span className="font-semibold text-gray-900"> Indicorns </span>
            - India’s unicorns built on collaboration, innovation, and resilience.
            Through a multi-domain ecosystem, TACTOS brings together founders, mentors,
            investors, and institutions to co-create a high-quality startup ecosystem.
          </p>


        </div>


        {/* Right Column: Static Image */}
        <div className="w-full lg:w-1/2 flex justify-center items-center mt-8 lg:mt-10 hidden md:flex">
          <div className="w-3/4 sm:w-3/4 md:w-3/4 lg:w-3/4 flex justify-center items-center">
            <img
              src={'/startupvalleynew.jpg'}
              alt="Mission Illustration"
              className="object-contain rounded-2xl"
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
